import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2, ArrowRight, GraduationCap } from "lucide-react";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = await register(email, password, name);
    setBusy(false);
    if (!res.ok) {
      setErr(res.error);
      return;
    }
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#f8f9fa] bg-grid" data-testid="register-page">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-md shadow-sm p-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-sm bg-[#0f172a] flex items-center justify-center">
            <GraduationCap size={18} className="text-white" />
          </div>
          <div>
            <div className="font-display font-bold text-[15px] text-slate-900">Rattrapage Builder</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500 font-semibold">
              Nouveau compte staff
            </div>
          </div>
        </div>

        <h1 className="font-display text-2xl font-semibold text-slate-900">Créer un accès</h1>
        <p className="text-sm text-slate-600 mt-1">Réservé à l'équipe pédagogique.</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <label className="label-xs block mb-2">Nom complet</label>
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Marie Dupont"
              data-testid="register-name-input"
              className="w-full px-3 py-2.5 text-sm border border-slate-300 rounded-sm bg-white focus:outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900"
            />
          </div>
          <div>
            <label className="label-xs block mb-2">E-mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="prenom.nom@ecole.fr"
              data-testid="register-email-input"
              className="w-full px-3 py-2.5 text-sm border border-slate-300 rounded-sm bg-white focus:outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900"
            />
          </div>
          <div>
            <label className="label-xs block mb-2">Mot de passe</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Min. 6 caractères"
              data-testid="register-password-input"
              className="w-full px-3 py-2.5 text-sm border border-slate-300 rounded-sm bg-white focus:outline-none focus:border-slate-900 focus:ring-1 focus:ring-slate-900"
            />
          </div>

          {err && (
            <div data-testid="register-error" className="text-sm text-[#b91c1c] bg-[#fef2f2] border border-red-200 px-3 py-2 rounded-sm">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit-button"
            className="w-full flex items-center justify-center gap-2 bg-[#0f172a] text-white px-4 py-3 rounded-sm font-semibold text-sm hover:bg-slate-800 transition-colors disabled:opacity-60"
          >
            {busy ? <Loader2 size={16} className="animate-spin" /> : <>Créer le compte <ArrowRight size={16} /></>}
          </button>

          <div className="text-sm text-slate-600 pt-2 text-center">
            Déjà un compte ?{" "}
            <Link to="/login" data-testid="goto-login" className="text-[#2563eb] font-semibold hover:underline">
              Se connecter
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
